<section class="page-container">
  <div class="flex min-w-0 items-center justify-between gap-4">
    <h1 class="main-heading min-w-0">Weekly Focus Dashboard - Report Details</h1>
    <app-navpath class="hidden md:block" />
  </div>
  <div class="mb-2 flex w-full flex-col gap-1 md:w-fit md:flex-row">
    <button class="shorter-btn misc-btn" (click)="onBack()">
      <fa-icon [icon]="faBan" class="mr-1"></fa-icon>Back to List
    </button>
  </div>
  <div class="content-container">
    <h2 class="sub-heading w-full border-b">A. SHOWROOM DUTY</h2>
    <app-data-form [dataFields]="showroomDutyFormField"></app-data-form>

    <div class="content-container mt-3 w-full overflow-x-auto">
      <app-data-table class="block min-w-[42rem]" [tableHeaders]="leadsTableHeaders" [tableEntries]="leadsTableEntries"></app-data-table>
    </div>

    <app-data-form [dataFields]="closingRatioFormField"></app-data-form>

    <h2 class="sub-heading w-full border-b mt-4">B. STANDBY DUTY</h2>
    <h4>PROSPECTING</h4>
    <app-data-form [dataFields]="standbyProspectingFormField"></app-data-form>

    <h4 class="mt-4">RESEARCH</h4>
    <app-data-form [dataFields]="standbyResearchFormField"></app-data-form>

    <h2 class="sub-heading w-full border-b mt-4">C. SPOTTERS & YOUR NETWORK</h2>

    <h3 class="mt-2">NEW SPOTTER'S NAMES</h3>
    <div class="content-container mt-3 w-full overflow-x-auto">
      <app-data-table class="block min-w-[30rem]" [tableHeaders]="spotters1TableHeaders" [tableEntries]="spotters1TableEntries"></app-data-table>
    </div>

    <h3 class="mt-4">REVISITED SPOTTER'S NAMES</h3>
    <div class="content-container mt-3 w-full overflow-x-auto">
      <app-data-table class="block min-w-[20rem]" [tableHeaders]="spotters2TableHeaders" [tableEntries]="spotters2TableEntries"></app-data-table>
    </div>

    <h3 class="mt-4">WHY NO BUSINESS FROM SPOTTER?</h3>
      <app-data-form
        [dataFields]="noBusinessSpotterForm"
        [dataName]="'noBusinessSpotterForm'"
    ></app-data-form>
    
    <h2 class="sub-heading w-full border-b mt-4">D. COMMERCIAL HOUSES</h2>
    <app-data-form [dataFields]="commercialHousesFormField"></app-data-form>

    <h2 class="sub-heading w-full border-b mt-4">E. MARKET ASSESSMENT</h2>
    <app-data-form [dataFields]="marketAssessmentFormField"></app-data-form>

    <h2 class="sub-heading w-full border-b mt-4">F. WHY NO CAT B CARS SALES</h2>
    <app-data-form [dataFields]="whyNoCatBFormField"></app-data-form>

    <h2 class="sub-heading w-full border-b mt-4">G. ANY OTHER COMMENTS OR SUGGESTIONS</h2>
    <app-data-form [dataFields]="commentsSuggestionsFormField"></app-data-form>

    <h2 class="mt-4">COMMENTS</h2>
      <app-data-form
        [dataFields]="remarksForm"
        [dataName]="'remarksForm'"
      ></app-data-form>

      <button
        class="shorter-btn save-btn"
        [disabled]="isSavingRemark"
        (click)="onSaveRemark()"
      >
        <fa-icon [icon]="faSave" class="mr-1"></fa-icon>Save Comment
      </button>

      <section *ngIf="remarksEntries.length" class="mt-6 space-y-3">
        <h2 class="sub-heading w-full border-b">OTHER COMMENTS</h2>
        <article
          *ngFor="let remark of remarksEntries"
          class="rounded border border-gray-200 p-4"
        >
          <div class="flex flex-col justify-between gap-1 md:flex-row">
            <strong>{{ remark.User }}</strong>
            <span class="text-sm text-gray-secondary">{{ remark.PostedDate }}</span>
          </div>
          <p class="mt-2 whitespace-pre-wrap break-words">{{ remark.Remarks }}</p>
          <div *ngIf="remark.SCResponse" class="mt-3 rounded bg-blue-50 p-3">
            <strong>Sales Consultant Response</strong>
            <p class="whitespace-pre-wrap break-words">{{ remark.SCResponse }}</p>
          </div>
        </article>
      </section>

  </div>
  <div class="mt-2 flex w-full flex-col gap-1 md:w-fit md:flex-row">
    <button class="shorter-btn misc-btn" (click)="onBack()">
      <fa-icon [icon]="faBan" class="mr-1"></fa-icon>Back to List
    </button>
  </div>
</section>
